import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue";
var _hoisted_1 = {
  class: "loading-indicator"
};
var _hoisted_2 = {
  class: "loading-indicator__wrapper"
};
var _hoisted_3 = {
  key: 0
};
var _hoisted_4 = {
  key: 0,
  class: "event-message"
};
var _hoisted_5 = {
  key: 1,
  class: "event-message"
};
var _hoisted_6 = {
  key: 2,
  class: "event-message"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_b_icon = _resolveComponent("b-icon");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("ul", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.loaders, function (item, index) {
    return _openBlock(), _createElementBlock("li", {
      key: index,
      class: _normalizeClass(item.classes)
    }, [!item.event ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 0
    }, [_createElementVNode("strong", null, _toDisplayString(item.type) + ":", 1), _cache[0] || (_cache[0] = _createTextVNode()), _createElementVNode("em", null, _toDisplayString(item.url), 1), _cache[1] || (_cache[1] = _createTextVNode()), _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1)), _createTextVNode(" " + _toDisplayString(item.flair) + " ", 1), _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1)), item.message ? (_openBlock(), _createElementBlock("span", _hoisted_3, [_createVNode(_component_b_icon, {
      icon: "exclamation"
    }), _createTextVNode(" " + _toDisplayString(item.message), 1)])) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true), item.event ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 1
    }, [_createElementVNode("strong", null, _toDisplayString(_ctx.$tf(item.flair)), 1), _cache[4] || (_cache[4] = _createTextVNode()), _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1)), item.status === 'progress' ? (_openBlock(), _createElementBlock("span", _hoisted_4, [_createVNode(_component_b_icon, {
      icon: "circle-nodes"
    }), _createTextVNode(" " + _toDisplayString(_ctx.$tf(item.messages.progress)), 1)])) : _createCommentVNode("", true), item.status === 'success' ? (_openBlock(), _createElementBlock("span", _hoisted_5, [_createVNode(_component_b_icon, {
      icon: "circle-check"
    }), _createTextVNode(" " + _toDisplayString(_ctx.$tf(item.messages.success)), 1)])) : _createCommentVNode("", true), item.status === 'fail' ? (_openBlock(), _createElementBlock("span", _hoisted_6, [_createVNode(_component_b_icon, {
      icon: "circle-xmark"
    }), _createTextVNode(" " + _toDisplayString(_ctx.$tf(item.messages.fail)), 1)])) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true)], 2);
  }), 128))])]);
}